import { render } from "./ContributionTable.vue?vue&type=template&id=799c6db2&scoped=true"
import script from "./ContributionTable.vue?vue&type=script&lang=js"
export * from "./ContributionTable.vue?vue&type=script&lang=js"

import "./ContributionTable.vue?vue&type=style&index=0&id=799c6db2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-799c6db2"]])

export default __exports__